import { Navigate, useRoutes } from "react-router-dom";
import Loadable from "react-loadable";

import DashboardLayout from "./layouts/dashboard/DashboardLayout";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import Calculator from "./pages/Calculator/Calculator";
import FineSummary from "./pages/fineCalculation/FineSummary";
import Loader from "./components/loaders/Loader";

const TeamMemberIncrement = Loadable({
  loader: () => import("./pages/teamMember/TeamMemberIncrement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Allowances = Loadable({
  loader: () => import("./pages/Allowances/Allowances"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const DetailImprovement = Loadable({
  loader: () => import("./pages/FeedbackImprovement/DetailImprovement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const EditImprovement = Loadable({
  loader: () => import("./pages/FeedbackImprovement/EditImprovement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddImprovement = Loadable({
  loader: () => import("./pages/FeedbackImprovement/AddImprovement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const FeedbackImprovement = Loadable({
  loader: () => import("./pages/FeedbackImprovement/FeedbackImprovement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const TeamLeave = Loadable({
  loader: () => import("./pages/teamMember/TeamLeave"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AdminLeavePendings = Loadable({
  loader: () => import("./pages/adminLeaves/AdminLeavePendings"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const LeaveReportDetails = Loadable({
  loader: () => import("./pages/adminLeaves/LeaveReportDetails"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const LeaveReportsList = Loadable({
  loader: () => import("./pages/adminLeaves/LeaveReportsList"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const LoanDetails = Loadable({
  loader: () => import("./pages/adminLoan/loanDetails"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const AddEditLoanByAdmin = Loadable({
  loader: () => import("./pages/adminLoan/AddEditLoanByAdmin"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const Loan = Loadable({
  loader: () => import("./pages/adminLoan/Loan"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const LoanRequestDetails = Loadable({
  loader: () => import("./pages/loan/loanRequestDetails"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddEditLoanRequest = Loadable({
  loader: () => import("./pages/loan/AddEditLoanRequest"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const LoanRequest = Loadable({
  loader: () => import("./pages/loan/LoanRequest"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const OtherTeams = Loadable({
  loader: () => import("./pages/myTeamMember/OtherTeams"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const MyTeamMembers = Loadable({
  loader: () => import("./pages/myTeamMember/MyTeamMembers"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Pay = Loadable({
  loader: () => import("./pages/payroll/pay"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const PayrollCompanyList = Loadable({
  loader: () => import("./pages/payroll/PayrollCompanyList"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const PayRoll = Loadable({
  loader: () => import("./pages/payroll/PayRoll"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const Lunch = Loadable({
  loader: () => import("./pages/lunch/Lunch"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Dashboard = Loadable({
  loader: () => import("./pages/dashboard/Dashboard"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const ForgotPassword = Loadable({
  loader: () => import("./pages/forgot-password/ForgotPassword"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const Login = Loadable({
  loader: () => import("./pages/login/Login"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const Page404 = Loadable({
  loader: () => import("./pages/page-404/Page404"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const Profile = Loadable({
  loader: () => import("./pages/profile/Profile"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const Register = Loadable({
  loader: () => import("./pages/register/Register"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const Settings = Loadable({
  loader: () => import("./pages/settings/Settings"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Roles = Loadable({
  loader: () => import("./pages/roles/Roles"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Expense = Loadable({
  loader: () => import("./pages/expense/Expense"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const ExpenseCatagory = Loadable({
  loader: () => import("./pages/expenseCatagory/ExpenseCatagory"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const AddEditExpenseOrCredit = Loadable({
  loader: () => import("./pages/expense/AddEditExpenseOrCredit"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const DetailsOfExpense = Loadable({
  loader: () => import("./pages/expense/expenseDetails"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Announcement = Loadable({
  loader: () => import("./pages/announcement/Announcement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const AddEditAnnouncement = Loadable({
  loader: () => import("./pages/announcement/AddEditAnnouncement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const DetailsOfAnnouncement = Loadable({
  loader: () => import("./pages/announcement/detailsOfAnnouncement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Designation = Loadable({
  loader: () => import("./pages/designation/Designation"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const TeamMember = Loadable({
  loader: () => import("./pages/teamMember/TeamMember"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const Company = Loadable({
  loader: () => import("./pages/company/Company"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const AddEditTeamMember = Loadable({
  loader: () => import("./pages/teamMember/AddEditTeamMember"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

// Interview Candidates

const InterviewCandidates = Loadable({
  loader: () => import("./pages/interview-candidates/InterviewCandidates"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const AddEditInterviewCandidates = Loadable({
  loader: () =>
    import("./pages/interview-candidates/components/AddEditInterviewCandidates"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Attendance = Loadable({
  loader: () => import("./pages/attendance/Attendance"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddEditAttendance = Loadable({
  loader: () => import("./pages/attendance/AddEditAttendance"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const LeavesteamMembers = Loadable({
  loader: () => import("./pages/teamMember/teamMemberAttandance"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const GenerateBalanceSheet = Loadable({
  loader: () => import("./pages/balanceSheet/GenerateBalanceSheet"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const AssetsCatagory = Loadable({
  loader: () => import("./pages/assetsCatagory/AssetsCatagory"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AssetsBrand = Loadable({
  loader: () => import("./pages/assetsBrand/AssetsBrand"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AssetsVendors = Loadable({
  loader: () => import("./pages/assetsVendors/AssetsVendors"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const CompanyAssets = Loadable({
  loader: () => import("./pages/companyAssets/CompanyAssets"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddEditAssets = Loadable({
  loader: () => import("./pages/companyAssets/components/AddEditAssets"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const DetailsOfAsset = Loadable({
  loader: () => import("./pages/companyAssets/detailsOfAssets"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const DetailsOfRepairAboutAssets = Loadable({
  loader: () => import("./pages/companyAssets/history_maintenance"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddEditRepairAndMaintenance = Loadable({
  loader: () =>
    import("./pages/companyAssets/components/AddEditRepairAndMaintenance"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const MyAttendance = Loadable({
  loader: () => import("./pages/myAttendance/MyAttendance"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const Events = Loadable({
  loader: () => import("./pages/Events/Events"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const UpcomingIncrement = Loadable({
  loader: () => import("./pages/Events/UpcomingIncrement"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const NewPassword = Loadable({
  loader: () => import("./pages/newPassword/NewPassword"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const LeaveRequest = Loadable({
  loader: () => import("./pages/leaves/LeaveRequest"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddEditLeaveRequest = Loadable({
  loader: () => import("./pages/leaves/AddEditLeaveRequest"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const TopUp = Loadable({
  loader: () => import("./pages/expenseTopUp/TopUp"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const AddEditTopUp = Loadable({
  loader: () => import("./pages/expenseTopUp/AddEditTopUp"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const TopUpDetails = Loadable({
  loader: () => import("./pages/expenseTopUp/TopUpDetails"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

// shop pages
const Shop = Loadable({
  loader: () => import("./pages/shop/Shop"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const OrdersHistory = Loadable({
  loader: () => import("./pages/shop/OrdersHistory"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const ManageProducts = Loadable({
  loader: () => import("./pages/shop/ManageProducts"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const MangeInventory = Loadable({
  loader: () => import("./pages/shop/ManageInventory"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddEditInventory = Loadable({
  loader: () => import("./pages/shop/components/AddEditInventory"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const BatchListing = Loadable({
  loader: () => import("./pages/shop/components/BatchListing"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

// =====================================

// const FeedbackTemplates = Loadable({
//   loader: () => import("./pages/surveyTemplates/FeedbackTemplates"),
//   // delay: 100,
//   timeout: 50,
//   loading: Loader,
// });

// const AddFeedbackTemplate = Loadable({
//   loader: () => import("./pages/surveyTemplates/addFeedbackTemplate"),
//   // delay: 100,
//   timeout: 50,
//   loading: Loader,
// });

// const EditFeedbackTemplate = Loadable({
//   loader: () => import("./pages/surveyTemplates/editFeedbackTemplate"),
//   // delay: 100,
//   timeout: 50,
//   loading: Loader,
// });

// const TemplatePreview = Loadable({
//   loader: () => import("./pages/surveyTemplates/templatePreview"),
//   // delay: 100,
//   timeout: 50,
//   loading: Loader,
// });

const AdminLeaveRequest = Loadable({
  loader: () => import("./pages/adminLeaves/AdminLeave"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddEditAdminLeaveRequest = Loadable({
  loader: () => import("./pages/adminLeaves/AddEditAdminLeaveRequest"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const SupportTickets = Loadable({
  loader: () => import("./pages/Support/SupportTickets"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const MySupportTickets = Loadable({
  loader: () => import("./pages/mySupport/SupportTickets"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const AddEditMemberSupportTickets = Loadable({
  loader: () => import("./pages/mySupport/AddEditMemberSupportTickets"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const MySupportTicketDetails = Loadable({
  loader: () => import("./pages/mySupport/MySupportTicketDetails"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const AddEditAdminSupportTickets = Loadable({
  loader: () => import("./pages/Support/AddEditAdminSupportTickets"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});
const SupportTicketDetails = Loadable({
  loader: () => import("./pages/Support/SupportTicketDetails"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

const GeneralSettings = Loadable({
  loader: () => import("./pages/GeneralSettings/GeneralSettings"),
  // delay: 100,
  timeout: 50,
  loading: Loader,
});

// ----------------------------------------------------------------------

import { useLocation } from "react-router-dom";

const PayrollWrapper = () => {
  const location = useLocation();

  return <PayRoll key={location.pathname} />;
};

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        { path: "dashboard", element: <Dashboard /> },
        { path: "roles", element: <Roles /> },
        { path: "leaves", element: <LeaveRequest /> },
        { path: "leaves/add-leaves", element: <AddEditLeaveRequest /> },
        { path: "leaves/edit-leaves/:id", element: <AddEditLeaveRequest /> },
        { path: "approved-admin-leave", element: <AdminLeaveRequest /> },
        { path: "pending-admin-leave", element: <AdminLeavePendings /> },
        {
          path: "leaves-report/details/:id",
          element: <LeaveReportDetails />,
        },
        {
          path: "leaves-report",
          element: <LeaveReportsList />,
        },
        {
          path: "admin-leave/admin-add-leave",
          element: <AddEditAdminLeaveRequest />,
        },
        {
          path: "admin-leave/admin-edit-leave/:id",
          element: <AddEditAdminLeaveRequest />,
        },
        { path: "profile", element: <Profile /> },
        { path: "settings", element: <Settings /> },
        { path: "new-password", element: <NewPassword /> },
        { path: "designation", element: <Designation /> },
        { path: "team-member", element: <TeamMember /> },
        { path: "team-member/add-team-member", element: <AddEditTeamMember /> },
        {
          path: "team-member/leaves-team-member/:id",
          element: <LeavesteamMembers />,
        },
        {
          path: "team-member/increment-team-member/:id",
          element: <TeamMemberIncrement />,
        },
        {
          path: "team-member/leaves/:id",
          element: <TeamLeave />,
        },

        {
          path: "team-member/edit-team-member/:id",
          element: <AddEditTeamMember />,
        },
        // interview Candidates
        { path: "interview-candidates", element: <InterviewCandidates /> },
        {
          path: "interview-candidates/add-candidate",
          element: <AddEditInterviewCandidates />,
        },
        {
          path: "interview-candidates/edit-candidate/:id",
          element: <AddEditInterviewCandidates />,
        },

        { path: "my-attendance", element: <MyAttendance /> },

        {
          path: "upcoming-birthday",
          element: <Events type="birthday" />,
        },
        {
          path: "upcoming-anniversary",
          element: <Events type="anniversary" />,
        },
        {
          path: "upcoming-increment",
          element: <UpcomingIncrement />,
        },

        { path: "allowances", element: <Allowances /> },
        { path: "calculator", element: <Calculator /> },
        { path: "improvement-feedback", element: <FeedbackImprovement /> },
        {
          path: "improvement-feedback/add-improvement",
          element: <AddImprovement />,
        },
        {
          path: "improvement-feedback/edit-improvement/:id",
          element: <EditImprovement />,
        },
        {
          path: "improvement-feedback/detail-improvement/:id",
          element: <DetailImprovement />,
        },
        { path: "companies", element: <Company /> },
        { path: "attendance", element: <Attendance /> },
        { path: "attendance/add-attendance", element: <AddEditAttendance /> },

        { path: "balance-sheet", element: <GenerateBalanceSheet /> },

        {
          path: "attendance/edit-attendance/:id",
          element: <AddEditAttendance />,
        },
        { path: "assets-categories", element: <AssetsCatagory /> },
        { path: "assets-brands", element: <AssetsBrand /> },
        { path: "assets-vendors", element: <AssetsVendors /> },
        { path: "company-assets", element: <CompanyAssets /> },
        { path: "company-assets/create-assets", element: <AddEditAssets /> },

        { path: "company-assets/edit-asset/:id", element: <AddEditAssets /> },
        {
          path: "company-assets/details-asset/:id",
          element: <DetailsOfAsset />,
        },
        {
          path: "company-assets/repair_details-asset/:id",
          element: <DetailsOfRepairAboutAssets />,
        },
        {
          path: "company-assets/add-repair-details-asset/:id",
          element: <AddEditRepairAndMaintenance />,
        },
        {
          path: "company-assets/edit-repair-details-asset/:id",
          element: <AddEditRepairAndMaintenance />,
        },
        {
          path: "/support-tickets",
          element: <SupportTickets />,
        },
        {
          path: "/my-support-tickets",
          element: <MySupportTickets />,
        },
        {
          path: "/my-support-tickets/add-my-support-tickets",
          element: <AddEditMemberSupportTickets />,
        },
        {
          path: "/my-support-tickets/edit-my-support-tickets/:id",
          element: <AddEditMemberSupportTickets />,
        },
        {
          path: "/admin-support-tickets/add-admin-support-tickets",
          element: <AddEditAdminSupportTickets />,
        },
        {
          path: "/admin-support-tickets/edit-admin-support-tickets/:id",
          element: <AddEditAdminSupportTickets />,
        },
        {
          path: "/support_tickets/:ticket_id",
          element: <SupportTicketDetails />,
        },
        {
          path: "/my-support-tickets/:ticket_id",
          element: <MySupportTicketDetails />,
        },
        {
          path: "/expenses-revenue-category",
          element: <ExpenseCatagory />,
        },
        {
          path: "/expense",
          element: <Expense />,
        },
        {
          path: "expense/add-expense",
          element: <AddEditExpenseOrCredit />,
        },
        {
          path: "expense/edit-expense/:id",
          element: <AddEditExpenseOrCredit />,
        },
        {
          path: "expense/detail-expense/:id",
          element: <DetailsOfExpense />,
        },

        // revenue

        {
          path: "/revenue",
          element: <Expense />,
        },
        {
          path: "revenue/add-revenue",
          element: <AddEditExpenseOrCredit />,
        },
        {
          path: "revenue/edit-revenue/:id",
          element: <AddEditExpenseOrCredit />,
        },
        {
          path: "revenue/detail-revenue/:id",
          element: <DetailsOfExpense />,
        },

        {
          path: "top-up",
          element: <TopUp />,
        },

        {
          path: "top-up/add-top-up",
          element: <AddEditTopUp />,
        },
        {
          path: "top-up/edit-top-up/:id",
          element: <AddEditTopUp />,
        },

        {
          path: "top-up/detail-top-up/:id",
          element: <TopUpDetails />,
        },

        // shop

        {
          path: "/shop",
          element: <Shop />,
        },
        {
          path: "/orders-history",
          element: <OrdersHistory />,
        },
        {
          path: "/manage-products",
          element: <ManageProducts />,
        },
        {
          path: "/manage-products/batch/:item_id",
          element: <BatchListing />,
        },

        // manage inventory
        {
          path: "/manage-inventory",
          element: <MangeInventory />,
        },
        {
          path: "/manage-inventory/add-inventory",
          element: <AddEditInventory />,
        },
        {
          path: "/manage-inventory/edit-inventory/:id",
          element: <AddEditInventory />,
        },

        // ==========================
        {
          path: "/announcement",
          element: <Announcement />,
        },
        {
          path: "/announcement/add-announcement",
          element: <AddEditAnnouncement />,
        },
        {
          path: "/announcement/edit-announcement/:id",
          element: <AddEditAnnouncement />,
        },

        {
          path: "/announcement/details-announcement/:id",
          element: <DetailsOfAnnouncement />,
        },

        {
          path: "/fine",
          element: <FineSummary />,
        },
        {
          path: "lunch",
          element: <Lunch />,
        },

        {
          path: "payroll",
          element: <PayrollCompanyList />,
        },
        {
          path: "my-payroll",
          element: <PayrollWrapper />,
        },
        {
          path: "payroll/:company_id/:month",
          element: <PayrollWrapper />,
        },
        {
          path: "payroll/add-pay-empl",
          element: <Pay />,
        },

        {
          path: "my-team-member",
          element: <MyTeamMembers />,
        },
        {
          path: "my-team-member/other-teams",
          element: <OtherTeams />,
        },
        {
          path: "my-loan-request",
          element: <LoanRequest />,
        },
        // {
        //   path: "my-loan-request-add-loan",
        //   element: <AddEditLoanRequest />,
        // },
        {
          path: "my-loan-request-Edit-loan/:id",
          element: <AddEditLoanRequest />,
        },
        {
          path: "my-loan-request-details-loan/:id",
          element: <LoanRequestDetails />,
        },
        {
          path: "loan",
          element: <Loan />,
        },
        {
          path: "loan-add-loan",
          element: <AddEditLoanByAdmin />,
        },
        {
          path: "loan-edit-loan/:id",
          element: <AddEditLoanByAdmin />,
        },
        {
          path: "loan-details-loan/:id",
          element: <LoanDetails />,
        },

        {
          path: "general-settings/",
          element: <GeneralSettings />,
        },

        ///////////////////////end//////////////////////////////

        ,
      ],
    },
    {
      path: "/",
      element: <LogoOnlyLayout />,
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "login", element: <Login /> },
        { path: "register", element: <Register /> },
        { path: "forgot-password", element: <ForgotPassword /> },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
